import { createContext, useContext, useCallback, ReactNode } from 'react'

interface LoadingContextType {
  /** 전역 오버레이 비활성화 — 항상 false */
  isLoading: boolean
  /** 호환용 no-op (기존 코드 제거 없이 유지) */
  startLoading: () => void
  stopLoading: () => void
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined)

const noop = () => {}

export function LoadingProvider({ children }: { children: ReactNode }) {
  const startLoading = useCallback(noop, [])
  const stopLoading = useCallback(noop, [])

  return (
    <LoadingContext.Provider value={{ isLoading: false, startLoading, stopLoading }}>
      {children}
    </LoadingContext.Provider>
  )
}

export function useLoading() {
  const context = useContext(LoadingContext)
  if (context === undefined) {
    throw new Error('useLoading must be used within a LoadingProvider')
  }
  return context
}
